import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalsComponent } from '../modals/modals.component';
import { SubjectService } from '../services/subject.service';
import { ActionsService } from '../services/actions.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';

export interface Subject {
  id:number;
  name:string;
  eik:string;
  dds:number;
  city:string;
  address:string;
  mol:string;
  default:number;
  iban_id:number;
}

@Component({
  selector: 'app-subject',
  templateUrl: './subject.component.html',
  styleUrls: ['./subject.component.css']
})
export class SubjectComponent implements OnInit {

  subjects:any;
  add:boolean;
  edit:boolean;
  delete:boolean;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private subjectService:SubjectService,private dialog: MatDialog,private actionService:ActionsService) { 
    this.getClients();
    this.getActions();
  }

  ngOnInit() {
  }

  getClients(){
    this.subjectService.getSubjects().subscribe(data=>{
       this.subjects = data,
       this.displayedColumns = ['name','eik','city','actions']
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Subject>(this.subjects);
      this.selection = new SelectionModel<Subject>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });  
    return this.subjects;
  }

  getActions(){
    this.actionService.moduleAction(7).subscribe(data=>{
      this.add = data.add_action;
      this.edit = data.edit_action;
      this.delete = data.delete_action;
    });
  }

  deleteModal(id, component): void {
    const dialogRef = this.dialog.open(ModalsComponent, {
      width: '250px',
      data: { id: id, component: component }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getClients();

    });
  }


}
